module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACBSURBVHgB7ZOxCYAwEEX/BWu1S2srNq7mJI6iG7iCjQOktBMXOKM2JoUcIkEwj4SEx+c4OA6IBCHVVZvqspdkE0mIgBpCFF7m+wXJF5kuO/vkjmRVg3j/jI6GGtd5anDXIYPMqa+Xj+N7Ahd4QqarwXY+SLI/nLJoU8C8EMEgEoQNhIYXJD0EjkEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare_b2c/ico-plus.png
// module id = 6BxV
// module chunks = 1